import React, { useEffect } from 'react';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from '@store/overviewDashboard/widgetMessageData/actions';
import { ViewersTabKey } from '@store/overviewDashboard/widgetMessageData/reducer';
import { activeTabSelector } from '@store/overviewDashboard/widgetMessageData/selectors';
import { setup } from '@store/overviewDashboard/impactedViewers/actions';
import { ViewToggleWrapper } from './styled';
import { Tabs } from './utils';

// viewers tab in dimensions sections has it's behaviour
// bound with the viewers tab in SPI
// this component handle all the connections and is mounted based on FF
function ViewToggle({ selectedTab, setTab }) {
  const dispatch = useDispatch();
  const activeBarTab = useSelector(activeTabSelector);

  const onChange = (e) => {
    const { value } = e.target;
    // switch to viewers bar chart when switching to viewers table
    if (value === Tabs.Viewers) {
      dispatch(setActiveTab(ViewersTabKey));
    }
    setTab(value);
  };

  useEffect(() => {
    // when viewers bar chart is selected switch to viewers table
    if (activeBarTab === ViewersTabKey) {
      setTab(Tabs.Viewers);
    } else {
      setTab(Tabs.Trends);
    }
  }, [activeBarTab]);

  // setup viewer table defaults
  useEffect(() => {
    dispatch(setup());
  }, []);

  return (
    <ViewToggleWrapper>
      <Radio.Group buttonStyle="solid" value={selectedTab} onChange={onChange}>
        <Radio.Button value={Tabs.Trends}>Top Trends</Radio.Button>
        <Radio.Button value={Tabs.Viewers}>Top Impacted Viewers</Radio.Button>
      </Radio.Group>
    </ViewToggleWrapper>
  );
}

export default ViewToggle;
